import { render, staticRenderFns } from "./juheAccount.vue?vue&type=template&id=10a88e2c&"
import script from "./juheAccount.vue?vue&type=script&lang=js&"
export * from "./juheAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports